export default "__VITE_ASSET__BrXWooMg__"